export default __webpack_public_path__ + "static/media/landscape3.2cfc98c1.jpeg";